import script from "./DocItemCheck.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemCheck.vue?vue&type=script&setup=true&lang=js"

import "./DocItemCheck.vue?vue&type=style&index=0&id=c7b39402&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7b39402"]])

export default __exports__